import { useTheme } from '../../context/ThemeContext';

interface BrandLogoProps {
  size?: number;
  className?: string;
  /** Fuerza isotipo-light.svg independientemente del tema global.
   *  Usar en fondos siempre oscuros (ej. Sidebar #0B1220). */
  forceLight?: boolean;
}

export default function BrandLogo({ size = 64, className = '', forceLight = false }: BrandLogoProps) {
  const { theme } = useTheme();
  const useLightIsotipo = forceLight || theme === 'dark';
  const src = useLightIsotipo ? '/isotipo-light.svg' : '/isotipo-dark.svg';

  return (
    <div
      className={`inline-flex items-center justify-center flex-shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={src}
        alt="TryQuiPus™"
        width={size}
        height={size}
        style={{ objectFit: 'contain', display: 'block' }}
        draggable={false}
      />
    </div>
  );
}
